{
  "add_multiple": "Добавить несколько",
  "add_options": "Добавить варианты",
  "enter_one_option_per_line": "Введите каждый вариант с новой строки",
  "bulk_options_placeholder": "Да\nНет\nВозможно\nи т. д.",
  "accept_invitation": "Принять приглашение",
  "accepts_formats": "Поддерживается {formats}",
  "access": "Доступ",
  "access_denied": "Доступ запрещен",
  "period_start_date": "Дата начала периода",
  "period_start_dates": "Даты начала периода",
  "access_granted": "Доступ разрешен",
  "actions": "Действия",
  "activity": "Активность",
  "add": "Добавить",
  "add_comment": "Добавить комментарий",
  "add_contact": "Добавить контакт",
  "add_description": "Добавить описание",
  "add_details": "Добавить детали",
  "add_field": "Добавить поле",
  "add_files": "Добавить файлы",
  "add_image": "Добавить изображение",
  "add_image_cta": "Выберите изображение",
  "add_item": "Добавить элемент",
  "add_option": "Добавить вариант",
  "add_record": "Добавить запись",
  "agree_with_privacy_policy": "Политикой конфиденциальности",
  "agree_with_terms_of_service": "Условиями использования",
  "all": "Все",
  "all_file_types_supported": "Поддерживаются все типы файлов",
  "all_categories": "Все категории",
  "all_time": "Все время",
  "amount": "Количество",
  "and": "и",
  "anonymous": "Анонимный",
  "application": "Приложение",
  "apply": "Применить",
  "apply_to": "Применить к",
  "archive": "Архивировать",
  "assign_to": "Ответственный",
  "attach": "Прикрепить",
  "attention": "Внимание",
  "author": "Автор",
  "automated": "Автоматические",
  "automation": "Автоматизация",
  "back": "Назад",
  "beta": "Бета",
  "background": "Фон",
  "balances": "Балансы",
  "budget": "Бюджет",
  "calculation": "Расчёт",
  "calendar": "Календарь",
  "cancel": "Отмена",
  "categories": "Категории",
  "change": "Изменить",
  "change_password": "Изменить пароль",
  "changes_saved_successfully": "Изменения были успешно сохранены",
  "changed": "Изменено",
  "chat_in": "Написать в",
  "choose_file_cta": "Выберите файл",
  "choose_color": "Выберите цвет",
  "choose_emoji": "Выберите эмодзи",
  "choose_field": "Выберите поле",
  "choose_section": "Выберите раздел",
  "choose_table": "Выберите таблицу",
  "choose_template": "Выбрать шаблон",
  "choose_type": "Выберите тип",
  "clear_all": "Очистить",
  "click_to_show_pages": "Нажмите, чтобы показать страницы",
  "click_to_view_answers": "Нажмите, чтобы посмотреть ответы",
  "close": "Закрыть",
  "co_owners": "Совладельцы",
  "code": "Код",
  "collapse": "Свернуть",
  "fullscreen": "На весь экран",
  "fullscreen_exit": "Выйти из полноэкранного режима",
  "toggle_pages_panel": "Показать или скрыть панель страниц",
  "colors": "Цвета",
  "column": "Колонка",
  "columns": "Колонки",
  "comment": "Комментарий",
  "comments": "Комментарии",
  "company": "Компания",
  "comparison": "Сравнение",
  "complete": "Завершить",
  "completed_percent": "{percent}% завершено",
  "condition": "Условие",
  "configuration": "Настройки",
  "confirm": "Подтвердить",
  "confirmation": "Подтверждение",
  "continue": "Продолжить",
  "or": "или",
  "conversion": "Конверсия",
  "copied": "Скопировано",
  "copy_failed": "Не удалось скопировать",
  "copy_from": "Копировать из",
  "copy_link": "Скопировать ссылку",
  "create": "Создать",
  "create_new": "Создать",
  "create_new_item": "Создать новый элемент",
  "create_shareable_link": "Создать публичную ссылку",
  "created": "Создано",
  "created_by": "Создано",
  "currency": "Валюта",
  "custom": "Другое",
  "custom_period": "Произвольный период…",
  "custom_period_description": "Выберите даты начала и конца, с учётом года или без",
  "choose_period": "Выбор периода",
  "filter_type": "Тип фильтра",
  "any_year": "Любой год",
  "period_group_exact": "Точные даты",
  "period_group_annual_this": "Текущие ежегодные",
  "period_group_annual_future": "Будущие ежегодные",
  "period_group_annual_past": "Прошлые ежегодные",
  "period_type_calendar": "Точные даты",
  "period_type_calendar_caption": "Фильтрация по точным датам с учётом года",
  "period_type_annual": "Ежегодные события",
  "period_type_annual_caption": "Дни рождения, годовщины и другие даты независимо от года",
  "period_hint_exact": "Фильтр по точным датам",
  "period_hint_annual": "Все ежегодные события",
  "danger_zone": "Опасная зона",
  "date": "Дата",
  "date_after": "После",
  "date_and_time": "Дата и время",
  "date_before": "До",
  "date_effective_from": "Дата",
  "date_effective_to": "Дата окончания",
  "date_format": "Формат даты",
  "date_from": "Дата с",
  "date_from_short": "С",
  "date_placeholder_dd_mm_yyyy": "дд/мм/гггг",
  "date_placeholder_dd_mm_yyyy_dot": "дд.мм.гггг",
  "date_placeholder_mm_dd_yyyy": "дд/мм/гггг",
  "date_placeholder_yyyy_mm_dd": "гггг/мм/дд",
  "date_to": "Дата по",
  "date_to_short": "По",
  "dates": "Даты",
  "day_of_month": "День месяца",
  "days": "Дни",
  "hours": "Часы",
  "minutes": "Минуты",
  "minutes_unit": "мин",
  "days_short": "{count} д",
  "delay": "Задержка",
  "delete": "Удалить",
  "remove": "Удалить",
  "delete_confirm": "Вы уверены, что хотите удалить?",
  "deleted": "Удален",
  "description": "Описание",
  "description_enter_using_editor": "Опишите, используя редактор",
  "details": "Детали",
  "hide_details": "Скрыть подробности",
  "disable": "Выключить",
  "disabled": "Выключено",
  "done": "Готово",
  "dont_equal": "Не совпадает",
  "duplicate": "Дублировать",
  "download": "Скачать",
  "download_pdf": "Скачать PDF",
  "document_preview_not_supported": "Предпросмотр недоступен для этого формата файла",
  "document_preview_download_instead": "Скачайте файл, чтобы открыть его на своем устройстве",
  "document_preview_preparing": "Готовим предпросмотр…",
  "document_preview_preparing_description": "Обычно это занимает несколько секунд.",
  "document_preview_failed": "Не удалось сформировать предпросмотр для этого файла",
  "draft": "Черновик",
  "drag_to_reorder": "Перетащите, чтобы изменить порядок",
  "due_date": "Срок",
  "duration": "Продолжительность",
  "other_time": "Другое время",
  "edit": "Изменить",
  "edit_list": "Изменить список",
  "edit_record": "Редактировать запись",
  "edited": "Изменён",
  "email_copied": "Email скопирован",
  "email_sent": "Email отправлен",
  "emoji": "Эмодзи",
  "employee_filter": "Фильтр по сотрудникам",
  "empty": "Пусто",
  "enable": "Включить",
  "enabled": "Включено",
  "end_date": "Дата окончания",
  "english": "Английский",
  "enter_answer": "Введите ответ",
  "equals": "Совпадает",
  "error": "Ошибка",
  "exclude": "Исключить",
  "exit": "Выйти",
  "export": "Экспорт",
  "export_to_pdf": "Экспорт в PDF",
  "export_to_xlsx": "Экспорт в XLSX",
  "f_last": "И. Фамилия",
  "file": "Файл",
  "file_dropzone_action": "Выберите",
  "file_dropzone_prefix": "Перетащите или",
  "file_dropzone_postfix": "для загрузки",
  "files": "Файлы",
  "filter": "Фильтр",
  "filter_apply": "Применить фильтр",
  "filter_clear": "Очистить фильтр",
  "filter_mode": "Тип фильтра",
  "filter_mode_date": "Полная дата",
  "filter_mode_day": "День в году",
  "filter_operator_custom": "Настраиваемый",
  "filter_preset_this_week": "Эта неделя",
  "filter_preset_last_week": "Прошлая неделя",
  "filter_preset_this_month": "Этот месяц",
  "filter_preset_last_month": "Прошлый месяц",
  "filter_preset_last_30_days": "Последние 30 дней",
  "filter_preset_last_3_months": "Последние 3 месяца",
  "filter_preset_this_quarter": "Этот квартал",
  "filter_preset_last_quarter": "Прошлый квартал",
  "filter_preset_this_year": "Этот год",
  "filter_preset_last_year": "Прошлый год",
  "filter_preset_next_week": "Следующая неделя",
  "filter_preset_next_month": "Следующий месяц",
  "filter_preset_next_quarter": "Следующий квартал",
  "filter_preset_next_year": "Следующий год",
  "filter_preset_annual_this_week": "Ежегодные события эта неделя",
  "filter_preset_annual_this_month": "Ежегодные события этот месяц",
  "filter_preset_annual_this_quarter": "Ежегодные события этот квартал",
  "filter_preset_annual_next_week": "Ежегодные события следующая неделя",
  "filter_preset_annual_next_month": "Ежегодные события следующий месяц",
  "filter_preset_annual_next_quarter": "Ежегодные события следующий квартал",
  "filter_preset_annual_last_week": "Ежегодные события прошлая неделя",
  "filter_preset_annual_last_month": "Ежегодные события прошлый месяц",
  "filter_preset_annual_last_quarter": "Ежегодные события прошлый квартал",
  "filter_preset_annual_last_30_days": "Ежегодные события последние 30 дней",
  "filter_preset_annual_last_3_months": "Ежегодные события последние 3 месяца",
  "finish_date": "Дата окончания",
  "first_date": "Первая дата",
  "first_day": "Первый день",
  "first_day_of_month": "Первый день месяца",
  "first_last": "Имя Фамилия",
  "folders": "Папки",
  "folder": "Папка",
  "friday": "Пятница",
  "from_count_of": "{count} из {count_all}",
  "full_access": "Полный доступ",
  "full_edit_access": "Полный доступ на изменение",
  "funnel": "Воронка",
  "gender_female": "Женский",
  "gender_male": "Мужской",
  "general": "Общее",
  "general_data": "Общие данные",
  "generate_with_ai": "Сгенерировать с помощью ИИ",
  "go_back": "Вернуться назад",
  "go_to_home": "На главную",
  "good_afternoon": "Добрый день",
  "good_evening": "Добрый вечер",
  "good_morning": "Доброе утро",
  "good_night": "Доброй ночи",
  "group_period_by_day": "По дням",
  "group_period_by_month": "По месяцам",
  "group_period_by_quarter": "По кварталам",
  "group_period_by_week": "По неделям",
  "group_period_by_year": "По годам",
  "grouping": "Группировка",
  "help": "Помощь",
  "help_ai_translation_notice": "Эта статья переведена с английского с помощью AI. Для важных деталей сверяйтесь с английской версией.",
  "help_center": "Справка",
  "help_feedback_caption": "Выберите один вариант ответа",
  "help_feedback_comment_dislike_prompt": "Помогите нам улучшить эту статью. Что вы искали или чего вам не хватило?",
  "help_feedback_comment_like_prompt": "Рады, что помогло! Есть что-то, что можно сделать ещё лучше?",
  "help_feedback_comment_neutral_prompt": "Помогите нам улучшить эту статью. Что можно сделать понятнее или полезнее?",
  "help_feedback_comment_placeholder": "Напишите комментарий",
  "help_feedback_rating_dislike": "Не помогло",
  "help_feedback_rating_like": "Помогло",
  "help_feedback_rating_neutral": "Частично помогло",
  "help_feedback_thank_you_text": "Мы используем отзывы, чтобы улучшать материалы справки.",
  "help_feedback_thank_you_title": "Спасибо за отзыв",
  "help_feedback_title": "Вам это помогло?",
  "help_original_language_notice": "Эта статья пока отображается на английском, потому что перевод еще не готов.",
  "hide": "Скрыть",
  "hide_all": "Скрыть все",
  "hide_breakdown": "Скрыть разбивку",
  "history": "История",
  "hours_short": "{count} ч",
  "image": "Изображение",
  "import": "Импорт",
  "in_days": "Через {days}",
  "in_progress": "В процессе",
  "include": "Включить",
  "insert": "Вставить",
  "invitation": "Приглашение",
  "invitation_subject": "Тема приглашения",
  "invite_from": "Приглашение от",
  "items": "Элементы",
  "label": "Название",
  "language": "Язык",
  "language_default": "Язык по умолчанию",
  "languages": "Языки",
  "last_day_of_month": "Последний день месяца",
  "last_first": "Фамилия Имя",
  "last_seen": "Последняя активность",
  "later": "Позже",
  "launch_plan": "План запуска",
  "leave": "Выйти",
  "leave_feedback": "Заполнить",
  "library": "Библиотека",
  "limits": "Ограничения",
  "link": "Ссылка",
  "link_copied": "Ссылка скопирована",
  "loading": "Загрузка",
  "location": "Локация",
  "locations": "Локации",
  "log_in": "Войти",
  "log_in_with_google": "Войти с помощью Google",
  "log_in_with_microsoft": "Войти с помощью Microsoft",
  "log_in_with_sso": "Войти через SSO",
  "login": "Войти",
  "logo": "Логотип",
  "logout": "Выйти",
  "manage_columns": "Настроить колонки",
  "manage_folders": "Управление папками",
  "manage_list": "Управление списком",
  "maybe": "Возможно",
  "merge": "Объединить",
  "message": "Сообщение",
  "milestone": "Этап",
  "minutes_short": "{count} мин",
  "monday": "Понедельник",
  "month_end_day_selection": "Для месяцев, в которых меньше 31 дня, автоматически будет выбран последний день месяца",
  "months": "Месяцы",
  "months_short": "{count} мес",
  "more": "Еще",
  "more_export_options": "Другие варианты экспорта",
  "more_filters": "Фильтры",
  "more_save_options": "Другие варианты сохранения",
  "move_to": "Переместить в",
  "my_team": "Моя команда",
  "n_a": "Н/Д",
  "name_pronunciation": "Произношение имени",
  "new_template": "Новый шаблон",
  "next": "Дальше",
  "no": "Нет",
  "none": "Нет",
  "no_access": "Нет доступа",
  "no_records_yet": "Записей ещё нет",
  "no_results_for": "Нет результатов для «{query}»",
  "no_results_were_found": "Результаты не найдены",
  "no_title": "Без названия",
  "no_votes": "Нет голосов",
  "non_anonymous": "Неанонимный",
  "not_selected": "Не выбрано",
  "nothing_found": "Ничего не найдено",
  "notifications": "Уведомления",
  "now": "Сейчас",
  "number_from_short": "От",
  "number_to_short": "До",
  "of": "{current} из {total}",
  "off": "Отключено",
  "ok": "ОК",
  "one_time": "Один раз",
  "only_me": "Только я",
  "only_me_admins_approvers": "Только я, администраторы и согласующие",
  "open": "Открыть",
  "open_new_tab": "Открыть в новой вкладке",
  "open_results": "Открыть результаты",
  "option": "Вариант",
  "options": "Варианты",
  "options_at_least_one": "Хотя бы один вариант должен быть добавлен",
  "original": "Оригинал",
  "original_file": "Оригинальный файл",
  "other": "Другое",
  "others": "других",
  "overview": "Обзор",
  "owner": "Владелец",
  "page": "Страница",
  "page_of": "Страница {page} из {total}",
  "pagination_pages": "Показано с {from} по {to} из {total}",
  "participants": "Участники",
  "participation": "Участие",
  "password": "Пароль",
  "pending_change_waiting_approval": "Запрос ожидает согласования",
  "per_hour": "в час",
  "per_month": "в месяц",
  "per_quarter": "в квартал",
  "per_week": "в неделю",
  "per_year": "в год",
  "period": "Период",
  "privacy": "Конфиденциальность",
  "periods": "Периоды",
  "last_year": "Последний год",
  "period_full_year": "{year}",
  "period_h1": "H1 {year}",
  "period_h2": "H2 {year}",
  "period_q1": "Q1 {year}",
  "period_q2": "Q2 {year}",
  "period_q3": "Q3 {year}",
  "period_q4": "Q4 {year}",
  "permission_type_edit": "Просмотр и редактирование",
  "permission_type_view_and_manage_requests": "Просмотр и управление запросами",
  "permission_type_none": "Нет доступа",
  "permission_type_view": "Просмотр",
  "persons": "Участники",
  "pdf_loading": "Загрузка PDF...",
  "pdf_error_title": "Не удалось открыть документ",
  "pdf_error_description": "При открытии документа что-то пошло не так. Попробуйте обновить страницу.",
  "pdf_load_failed": "Не удалось загрузить PDF",
  "pdf_not_selected": "PDF не выбран",
  "pdf_render_failed": "Не удалось отобразить PDF",
  "pdf_unsupported_browser_title": "Браузер не поддерживается",
  "pdf_unsupported_browser_description": "Не удалось открыть документ. Возможно, ваш браузер устарел — обновите его или откройте страницу в актуальной версии.",
  "photo": "Фото",
  "profile_photo": "Фото профиля",
  "pick_a_date_range": "Выберите период дат",
  "pin": "Закрепить",
  "policy": "Политика",
  "present_time": "Настоящее время",
  "preview": "Просмотр",
  "previous": "Назад",
  "progress": "Прогресс",
  "published": "Опубликовано",
  "quantity_short": "Кол-во",
  "questionnaire": "Вопросник",
  "questions": "Вопросы",
  "recent": "Недавние",
  "recurring": "Повторяющееся",
  "reorder": "Изменить сортировку",
  "reordering": "Изменение сортировки",
  "reply": "Ответить",
  "reporting": "Отчетность",
  "reports": "Отчеты",
  "request": "Запрос",
  "request_headers": "Заголовки запроса",
  "request_payload": "Тело запроса",
  "requested_document_not_found": "Упс! Мы не смогли найти запрошенный документ",
  "requests": "Запросы",
  "reset": "Сбросить",
  "response_rate": "Процент ответов",
  "responses": "Ответы",
  "restore": "Восстановить",
  "results": "Результаты",
  "retry": "Повторить",
  "review": "Просмотр",
  "review_all": "Просмотреть все",
  "russian": "Русский",
  "saturday": "Суббота",
  "save": "Сохранить",
  "save_and_continue": "Сохранить и продолжить",
  "save_as_pdf": "Сохранить в PDF",
  "scope": "Область применения",
  "search": "Поиск",
  "search_in_profile": "Поиск по профилю",
  "search_in_profile_placeholder": "Поиск по профилю...",
  "search_by_name": "Поиск по имени",
  "search_start_typing": "Начните вводить",
  "second_date": "Вторая дата",
  "second_day": "Второй день",
  "section": "Раздел",
  "security": "Безопасность",
  "select": "Выбрать",
  "select_all": "Выбрать все",
  "select_fields": "Выберите поля",
  "sent": "Отправлено",
  "set_timeframe": "Установить временные рамки",
  "set_your_password": "Установите пароль",
  "settings": "Настройки",
  "setup": "Настроить",
  "shareable_link": "Публичная ссылка",
  "show": "Показать",
  "show_all": "Показать все",
  "show_details": "Показать подробности",
  "show_breakdown": "Показать разбивку",
  "show_less": "Свернуть",
  "show_more": "Показать больше",
  "show_more_template": "Показать еще {count}",
  "show_results": "Показать результаты",
  "sidebar_collapse": "Свернуть панель",
  "sidebar_expand": "Развернуть панель",
  "sidebar_resize": "Изменить ширину панели",
  "skip": "Пропустить",
  "skype": "Skype",
  "snooze": "Напомнить позже",
  "source": "Источник",
  "sort_by_original_order": "Сортировать по исходному порядку",
  "sort_by_popularity": "Сортировать по популярности",
  "start_date": "Дата начала",
  "status": "Статус",
  "status_completed": "Завершен",
  "status_failed": "Ошибка",
  "status_cancelled": "Отменен",
  "status_invited": "Приглашены",
  "status_waiting": "Ожидание",
  "status_paused": "Приостановлен",
  "status_pending_launch": "Запланирован",
  "status_running": "Идет",
  "stay": "Остаться",
  "submit": "Отправить",
  "submit_the_request": "Отправить заявку",
  "summary": "Сводка",
  "summary_permissions_description": "Контент отображается в соответствии с вашими правами доступа.",
  "sunday": "Воскресенье",
  "switch_off": "Выключено",
  "switch_on": "Включено",
  "table": "Таблица",
  "table_of_contents": "Содержание",
  "tax_id": "ИНН",
  "telegram": "Telegram",
  "template": "Шаблон",
  "templates": "Шаблоны",
  "text": "Текст",
  "timeframe": "Период",
  "theme": "Тема",
  "dark_mode": "Тёмная тема",
  "light_mode": "Светлая тема",
  "system_mode": "Авто (как в системе)",
  "color_mode": "Оформление",
  "thursday": "Четверг",
  "till": "до",
  "time": "Время",
  "time_ago": "{time} назад",
  "time_in_location": "Время в локации",
  "time_to_complete": "Время прохождения",
  "timezone": "Часовой пояс",
  "timezone_default": "Часовой пояс по умолчанию",
  "title": "Название",
  "today": "Сегодня",
  "tomorrow": "Завтра",
  "total": "Всего",
  "total_days": "Количество дней",
  "total_growth": "Общий рост",
  "transfer": "Передать",
  "tuesday": "Вторник",
  "type": "Тип",
  "type_files_supported": "{types} поддерживаемые типы файлов",
  "unit_of_time": "Единица времени",
  "unknown": "Неизвестно",
  "unpin": "Открепить",
  "unsaved_changes_may_be_lost_description": "Если вы сейчас выйдете, несохранённые данные будут утеряны. Вы уверены, что хотите выйти?",
  "unsaved_changes_may_be_lost_title": "Несохранённые данные могут быть утеряны",
  "untitled": "Без названия",
  "update": "Обновить",
  "update_progress": "Обновить прогресс",
  "updated": "Обновлено",
  "upload_file": "Загрузить файл",
  "upload_file_drag_and_drop": "Перетащите файл сюда ...",
  "upload_file_drag_and_drop_description": "Перетащите файл сюда или нажмите для выбора файлов",
  "upload_logo": "Загрузить логотип",
  "upload_logo_cta": "Выберите логотип",
  "upload_new": "Загрузить",
  "upload_photo": "Загрузить фотографию",
  "url": "URL",
  "url_alias": "URL путь",
  "use": "Использовать",
  "user_created": "Пользовательские",
  "value": "Значение",
  "value_number": "Значение (число)",
  "verify": "Подтвердить",
  "view": "Посмотреть",
  "view_all": "Посмотреть все",
  "view_all_responses": "Просмотреть все ответы",
  "view_history": "Посмотреть историю",
  "view_responses": "Просмотр ответов",
  "visibility": "Видимость",
  "visible_to": "Видно для",
  "visual": "Визуал",
  "waiting_for_external": "Ожидание выполнения",
  "skipped_by_condition": "Отклонено по условию",
  "wednesday": "Среда",
  "week": "Неделя",
  "weeks": "Недели",
  "weeks_short": "{count} нед",
  "weight_custom": "Настроить",
  "weight_default": "По умолчанию",
  "welcome": "Добро пожаловать",
  "word_file": "Word файл",
  "words_in_comments": "Слова в комментариях",
  "workflow": "Автоматизация",
  "year_to_date": "С начала года",
  "years_short": "{count} г",
  "yes": "Да",
  "yesterday": "Вчера",
  "you": "Вы",
  "you_changes_were_saved": "Ваши изменения были сохранены",
  "your_logo": "Ваш логотип",
  "zoom_in": "Увеличить",
  "zoom_out": "Уменьшить",
  "~": "~",
  "uploaded_by": "Загрузил",
  "seconds_short": "{count} сек",
  "sort_asc": "Сортировать по возрастанию",
  "sort_desc": "Сортировать по убыванию",
  "add_filter": "Добавить фильтр",
  "all_templates": "Все шаблоны",
  "rename_template_folder": "Переименовать папку",
  "delete_template_folder": "Удалить папку",
  "delete_template_folder_named": "Удалить папку «{title}»?",
  "folders_load_failed": "Не удалось загрузить папки. Попробуйте позже.",
  "no_other_folders": "Других папок нет",
  "link_label": "Подпись ссылки",
  "display_as_text": "Уст. заголовок",
  "editor_align_left": "По левому краю",
  "editor_align_center": "По центру",
  "editor_align_right": "По правому краю",
  "editor_align_justify": "По ширине",
  "editor_text_color": "Цвет текста",
  "editor_background_color": "Цвет заливки",
  "editor_color_default": "По умолчанию",
  "editor_no_background": "Без заливки",
  "editor_color_gray": "Серый",
  "editor_color_red": "Красный",
  "editor_color_orange": "Оранжевый",
  "editor_color_yellow": "Жёлтый",
  "editor_color_green": "Зелёный",
  "editor_color_blue": "Синий",
  "editor_color_violet": "Фиолетовый",
  "editor_horizontal_rule": "Разделитель",
  "editor_clear_formatting": "Очистить формат",
  "editor_video": "Видео",
  "editor_video_link": "Вставить ссылку",
  "editor_video_file": "Загрузить файл",
  "editor_video_link_prompt": "Ссылка на YouTube, Vimeo или файл .mp4/.webm",
  "editor_video_link_unsupported": "Вставьте ссылку на YouTube, Vimeo или прямую ссылку на .mp4/.webm",
  "editor_video_remove": "Удалить видео",
  "editor_pdf": "PDF",
  "editor_pdf_remove": "Удалить PDF"
}
